import { SVGProps } from "react";

export function CalendarClock({
  style,
  className,
  ...props
}: {
  style?: React.CSSProperties;
  className?: string;
} & SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      style={style}
      className={className}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1222 3C15.7 3 16.7889 4.19678 16.7889 5.67188V10.125H32.8889V5.67188C32.8889 4.19678 34.0778 3 35.5556 3C37.0333 3 38.2222 4.19678 38.2222 5.67188V10.125H42.6667C46.5889 10.125 49.7778 13.3146 49.7778 17.25V24.375H5.23333V52.875C5.23333 53.8547 6.12889 54.6562 7.01111 54.6562H31.6111C32.9667 56.7492 34.7222 58.5639 36.7556 60H7.11111C3.18333 60 0 56.8049 0 52.875V17.25C0 13.3146 3.18333 10.125 7.11111 10.125H11.5556V5.67188C11.5556 4.19678 12.7444 3 14.2222 3H14.1222ZM64 43.9688C64 52.8193 56.8333 60 48 60C39.1667 60 31.9 52.8193 31.9 43.9688C31.9 35.1182 39.1667 27.9375 48 27.9375C56.8333 27.9375 64 35.1182 64 43.9688ZM46.1222 36.8438V43.9688C46.1222 44.9484 47.0222 45.75 47.9 45.75H53.3333C54.3111 45.75 55.1111 44.9484 55.1111 43.9688C55.1111 42.9891 54.3111 42.1875 53.3333 42.1875H49.6778V36.8438C49.6778 35.8641 48.9778 35.0625 47.9 35.0625C47.0222 35.0625 46.1222 35.8641 46.1222 36.8438Z"
        fill="black"
      />
    </svg>
  );
}
